import ReactMarkdown from 'react-markdown';

/** Блок описания из API (HTML / markdown / plain) — контент из настроек организации. */
export function RichTextBlock(props: {
  html: string | null;
  format: 'html' | 'markdown' | 'plain';
  className?: string;
}) {
  const { html, format, className = 'text-sm text-[var(--text)]' } = props;
  if (!html?.trim()) {
    return null;
  }
  if (format === 'html') {
    return (
      <div
        className={`${className} min-w-0 [&_a]:text-[var(--accent)] [&_a]:underline [&_a]:underline-offset-2 [&_a:focus-visible]:rounded-sm [&_a:focus-visible]:outline-none [&_a:focus-visible]:ring-2 [&_a:focus-visible]:ring-[var(--focus-ring)] [&_p]:mb-2 [&_p]:last:mb-0 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_img]:max-w-full [&_img]:rounded-xl [&_table]:block [&_table]:max-w-full [&_table]:overflow-x-auto`}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    );
  }
  if (format === 'markdown') {
    const mdBase =
      'min-w-0 [&_a]:text-[var(--accent)] [&_a]:underline [&_a]:underline-offset-2 [&_a:focus-visible]:rounded-sm [&_a:focus-visible]:outline-none [&_a:focus-visible]:ring-2 [&_a:focus-visible]:ring-[var(--focus-ring)] [&_p]:mb-2 [&_p]:last:mb-0 [&_ul]:my-2 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:my-2 [&_ol]:list-decimal [&_ol]:pl-5 [&_li]:my-0.5 [&_strong]:font-semibold [&_code]:rounded-sm [&_code]:bg-[var(--bg-soft)] [&_code]:px-1 [&_code]:text-[13px] [&_img]:max-w-full [&_img]:rounded-xl [&_pre]:max-w-full [&_pre]:overflow-x-auto';
    return (
      <div className={`${className} ${mdBase}`}>
        <ReactMarkdown
          components={{
            h1: ({ children }) => (
              <h2 className="mt-3 text-base font-semibold text-[var(--text)] first:mt-0">{children}</h2>
            ),
            h2: ({ children }) => <h3 className="mt-2 text-sm font-semibold text-[var(--text)]">{children}</h3>,
            h3: ({ children }) => <h4 className="mt-2 text-sm font-medium text-[var(--text)]">{children}</h4>
          }}
        >
          {html}
        </ReactMarkdown>
      </div>
    );
  }
  return <p className={`${className} whitespace-pre-wrap`}>{html}</p>;
}
